import React , {useState, useEffect}from 'react';
import axios from 'axios';
import config from '../../config/apiConfig';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import Procesando from '../Generales/Procesando'
//import {sucursal} from '../Generales/Storage';

function ConfiguracionSII(props) {

const [cargando, setCargando] = useState(false);
const [rut, setRut] = useState('');
const [razonSocial, setRazonSocial] = useState('');
const [giro, setGiro] = useState('');
const [direccion, setDireccion] = useState('');
const [comuna, setComuna] = useState('');
const [codigoActividades, setCodigoActiviades] = useState('');
const [fechaResolucion, setFechaResolucion] = useState('');
const [numeroResolucion, setNumeroResolucion] = useState('');
const [certificadoRUt, setCertificadoRut] = useState('');
const [certificadoNombre, setCertificadoNombre] = useState('');
const [certificadoPassword, setCertificadoPassword] = useState('');

useEffect(()=>{
    const token = localStorage.getItem("token");
    axios.defaults.headers.common["token"] = token;
    getDatos()
},[]);

async function getDatos(){
    setCargando(true);
    await axios.get(config.api_url+'/configuracion/sii/').then(resp=>{
        console.log(resp.data)
        if (resp.data.completado){ 
            let datos = resp.data.datos;
            setRut(datos.rut_empresa)
            setRazonSocial(datos.razon_social);
            setGiro(datos.giro);
            setDireccion(datos.direccion);
            setComuna(datos.comuna);
            setCodigoActiviades(datos.codigos_actividades);
            setFechaResolucion(datos.fecha_resolucion);
            setNumeroResolucion(datos.nro_resolucion);
            setCertificadoNombre(datos.certificado_nombre);
            setCertificadoRut(datos.certificado_rut);
            setCertificadoPassword(datos.certificado_password);
            setCargando(false);
        }else{
            setCargando(false);
            toast.error(resp.data.mensaje);
        }
     }).catch(error=>{
        setCargando(false);
        toast.error("Se ha generado un error al traer los datos!");
    })  
}



async function Guardar(){
    setCargando(true);
    let parametros ={rutEmpresa:rut, razonSocial:razonSocial, giro:giro, direccion:direccion, comuna:comuna, codigoActividades:codigoActividades, fechaResolucion:fechaResolucion,numeroResolucion:numeroResolucion,
         certificadoRut:certificadoRUt,certificadoNombre:certificadoNombre, certificadoPassword:certificadoPassword}
    await axios.post(config.api_url+'/configuracion/sii/', parametros).then(resp=>{
        console.log(resp.data)
        if (resp.data.completado){ 
            toast.success(resp.data.mensaje);
            setCargando(false);
        }else{
            toast.success(resp.data.mensaje);
            setCargando(false);
        }
     }).catch(error=>{
        setCargando(false);
        toast.error("Se ha generado un error al guardar los datos!");
    })  
}


return  (       
        <div className='card' style={{height:"100vh"}}>
            <ToastContainer />
            <Modal
                open={cargando}
                showCloseIcon={false}
                center
                >
                <Procesando/>
            </Modal>
            <div className='card-header'>
                <div className='row'>
                    <div className='col-md-4'>
                            <a href='/configuracion/home/'><i class="bi bi-arrow-left-short"></i>Regresar</a>   
                        </div>
                    <div className='col-md-4 titulo-formulario'>
                        <label>Configuración SII</label>
                    </div>
                </div>
            </div>
            <br/>
            <div className='card-body'>
                <div className='row'>
                <div className='col-md-12'>
                    <div className='container'>
                       <div className='row'>
                            <div className='col-2'>
                                <label>Rut:</label>
                            </div>
                            <div className='col-8'>
                                <input type='text' className='form-control' value={rut} onChange={(ev)=>setRut(ev.target.value)}/>
                            </div>
                       </div>
                       <br></br>
                       <div className='row'>
                            <div className='col-2'>
                                <label>Razón Social:</label>
                            </div>
                            <div className='col-8'>
                                <input type='text' className='form-control' value={razonSocial} onChange={(ev)=>setRazonSocial(ev.target.value)}/>
                            </div>
                       </div>
                       <br></br>
                       <div className='row'>
                            <div className='col-2'>
                                <label>Giro:</label>
                            </div>
                            <div className='col-8'>
                                <input type='text' className='form-control' value={giro} onChange={(ev)=>setGiro(ev.target.value)}/>
                            </div>
                       </div>
                       <br/>
                       <div className='row'>
                            <div className='col-2'>
                                <label>Dirección:</label>
                            </div>
                            <div className='col-8'>
                                <input type='text' className='form-control' value={direccion} onChange={(ev)=>setDireccion(ev.target.value)}/>
                            </div>
                       </div>
                       <br/> 
                       <div className='row'>
                            <div className='col-2'>
                                <label>Comuna:</label>
                            </div>
                            <div className='col-8'>
                                <input type='text' className='form-control' value={comuna} onChange={(ev)=>setComuna(ev.target.value)}/>
                            </div>
                       </div>
                       <br/>
                       <div className='row'>
                            <div className='col-2'>
                                <label>Código actividades:</label>
                            </div>
                            <div className='col-8'>
                                <input type='text' className='form-control' value={codigoActividades} onChange={(ev)=>setCodigoActiviades(ev.target.value)}/>
                            </div>
                       </div>
                       <br/>
                       <div className='row'>
                            <div className='col-2'>
                                <label>Fecha Resolución:</label>
                            </div>
                            <div className='col-8'>
                                <input type='text' className='form-control' value={fechaResolucion} onChange={(ev)=>setFechaResolucion(ev.target.value)}/>
                            </div>
                       </div>
                       <br/>
                       <div className='row'>
                            <div className='col-2'>
                                <label>Numero Resolución:</label>
                            </div>
                            <div className='col-8'>
                                <input type='text' className='form-control' value={numeroResolucion} onChange={(ev)=>setNumeroResolucion(ev.target.value)}/>
                            </div>
                       </div>
                       <br/>
                       <div className='row'>
                            <div className='col-2'>
                                <label>Certificado Rut:</label>
                            </div>
                            <div className='col-8'>
                                <input type='text' className='form-control' value={certificadoRUt} onChange={(ev)=>setCertificadoRut(ev.target.value)}/>
                            </div>
                       </div>
                       <br/>
                       <div className='row'>
                            <div className='col-2'>
                                <label>Certificado Nombre:</label>
                            </div>
                            <div className='col-8'>
                                <input type='text' className='form-control' value={certificadoNombre} onChange={(ev)=>setCertificadoNombre(ev.target.value)}/>
                            </div>
                       </div>
                       <br/>
                       <div className='row'>
                            <div className='col-2'>
                                <label>Password certificado:</label>
                            </div>
                            <div className='col-4'>
                                <input type='password' className='form-control' value={certificadoPassword} onChange={(ev)=>setCertificadoPassword(ev.target.value)}/>
                            </div>
                       </div>
                    </div>  
                </div>
                </div>
                <br/>
                <div className='row'>
                    <div className='col-md-12'>
                        <button className='btn btn-primary' onClick={Guardar}> Guardar </button>
                    </div>
                </div>
            </div>
            
            
        </div>
    
    );
}

export default ConfiguracionSII;